module.exports = __webpack_public_path__ + "static/media/Default.e8946535.png";